export const INVALID_CHARS_ERROR_MSG = 'h24_validation_error_form_invalid_characters';

export const GLOBAL_REGEX_FLAG = 'g';
